export default __webpack_public_path__ + "static/media/frappe.f8dc1865.png";